module.exports = __webpack_public_path__ + "static/media/conferinta-icon.c2184997.svg";